import * as ToggleSwitch from 'tradera/components/form-controls/toggle-switch/toggle-switch';
import { classNames } from 'tradera/utils/class-names';
import styles from './menu-item-toggle.module.scss';

type MenuItemWithToggleProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    id: string;
    name?: string;
    value?: string;
    disabled?: boolean;
    className?: string;
    icon?: React.ReactNode;
    border?: boolean;
    size?: 'small' | 'medium';
};

export const MenuItemWithToggle = ({
    label,
    checked,
    onChange,
    id,
    name,
    value,
    disabled = false,
    className = '',
    icon,
    border = false,
    size = 'small'
}: MenuItemWithToggleProps) => {
    const containerClass = classNames(
        'd-flex flex-row align-items-center justify-content-between pr-2',
        styles.item,
        icon ? styles.itemWithIcon : styles.itemDefault,
        className
    );

    return (
        <li className={classNames(border && 'border-bottom')}>
            <ToggleSwitch.Root
                className={containerClass}
                disabled={disabled}
                id={id}
                name={name}
                value={value}
                checked={checked}
                size={size}
                onChange={onChange}>
                {icon && (
                    <span
                        className={classNames(
                            'd-flex align-items-center justify-content-center',
                            styles.itemImage
                        )}>
                        {icon}
                    </span>
                )}
                <span className="flex-grow-1 text-styled">{label}</span>
                <ToggleSwitch.Indicator className="ml-auto" size={size} />
            </ToggleSwitch.Root>
        </li>
    );
};
